import React from 'react';
import cx from 'classnames';

import { cellWidth } from 'modules/job-review/utils';

/**
 * TODO(driver-review)
 * This would be used in the moment we want to add times between stops
 * <div className="stop-timings__time">{isEmpty ? '17m' : '1h 23m'}</div>
 */

const DriverDayStopSeparator = ({ className, isEmpty, skin }) => {
  return (
    <div className={className}>
      <div className="container">
        <div className="cell cell__nogrow cell__skin" {...cellWidth('24px')} />
        <div className="cell cell__right cell__padding distance" {...cellWidth('260px')} />
        <div
          {...cellWidth('125px')}
          className={cx('stop-timings', {
            'stop-timings__is_empty': isEmpty,
          })}
        ></div>
      </div>
    </div>
  );
};

export default DriverDayStopSeparator;
